// extracted by mini-css-extract-plugin
export default {"componentWrapper":"InternalInfo_componentWrapper__xh1va"};